export type UserSettings = {
  timeTrackingDefaultProjectCostCenterSelectionView: SelectionView
  articleDialogDefaultSelectionView: SelectionView
}

export type UpdateUserSettingsRequest = {
  timeTrackingDefaultProjectCostCenterSelectionView: SelectionView
  articleDialogDefaultSelectionView: SelectionView
}

export enum SelectionView {
  LIST = 'LIST',
  QR_CODE_SCANNER = 'QR_CODE_SCANNER',
}
